import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-canvas py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-247" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-248" data-mp="3fxb2uio71qc6">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-navy-900 sm:text-4xl" data-id="element-249" data-mp="3b1ch72u92mfg">
          Testimonios de docentes que ya tienen su Megapack
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-250" data-mp="31zd2ih6pjufo">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-navy-100 bg-white p-6 shadow-sm" data-id="element-251" data-mp="2x1utkqsoxf7o" data-mpi={index}>
              <div className="flex text-sun-500" aria-label="5 de 5 estrellas" data-id="element-252" data-mp="h55ba4bmvzy5">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-253" data-mp="m2op534f6apk" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-navy-700" data-id="element-254" data-mp="c6bwm8km22we">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-navy-100 pt-4" data-id="element-255" data-mp="zw64sctzj3ab">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-navy-900 text-sm font-extrabold text-white" data-id="element-256" data-mp="14w28eayrsspc">
                  {initials}
                </span>
                <span data-id="element-257" data-mp="v57mj7pfrv4f">
                  <b className="block text-sm text-navy-900" data-id="element-258" data-mp="v4o65vffpesi">{name}</b>
                  <small className="text-xs text-navy-700/80" data-id="element-259" data-mp="1ivk0p0b9yo3g">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}